import { Box } from '@chakra-ui/react';
import {
  parseAsArrayOf,
  parseAsInteger,
  parseAsString,
  useQueryStates,
} from 'nuqs';
import React, { useTransition } from 'react';

import {
  Consumption,
  DriveTypeList,
  FuelTypeList,
  TransmissionTypeList,
} from '@/services/filters/new-filters.service';

import { MinMaxFilter } from '../min-max-slider/min-max-slider';
import { NewFilter } from '../new-filter/new-filter';

import { NewDriveTypeFilter } from './drivetype/new-drive-type-filter';
import { NewFuelTypeFilter } from './fueltype/new-fuel-type-filter';
import styles from './new-more-filters.module.scss';
import { NewTransmissionFilter } from './transmission/new-transmission-filter';
import { useQueryNonce } from '../utils';

export const NewMoreFilters: React.FC<{
  defaultFuelConsumption: Consumption;
  count: number;
  transmissionTypes?: TransmissionTypeList;
  driveTypes?: DriveTypeList;
  fuelTypes?: FuelTypeList;
}> = ({
  defaultFuelConsumption,
  transmissionTypes,
  driveTypes,
  fuelTypes,
  count,
}) => {
  const [_isPending, startTransition] = useTransition();

  const { generate } = useQueryNonce();

  const [_, setQuery] = useQueryStates(
    {
      fueltype: parseAsArrayOf(parseAsString),
      fueleconomyfrom: parseAsInteger,
      fueleconomyto: parseAsInteger,
      transmission: parseAsArrayOf(parseAsString),
      drivetype: parseAsArrayOf(parseAsString),
    },
    { shallow: false, startTransition },
  );

  return (
    <NewFilter
      label="More Filters"
      placement="bottom-end"
      count={count}
      onClear={() => {
        setQuery(null);
        generate();
      }}
    >
      <div className={styles.wrapper}>
        <div className={styles.filtersContainer}>
          <div>
            {fuelTypes && (
              <div className={styles.filterSection}>
                <NewFuelTypeFilter fuelTypes={fuelTypes} />
              </div>
            )}
            <div className={styles.filterSection}>
              <Box className={styles.sliderWrapper}>
                <MinMaxFilter
                  min={defaultFuelConsumption.min || 1}
                  max={defaultFuelConsumption.max || 30}
                  queryKey="fueleconomy"
                  label="Litres/100km"
                />
              </Box>
            </div>
          </div>
          <div>
            {transmissionTypes && transmissionTypes.length > 0 ? (
              <div className={styles.filterSection}>
                <NewTransmissionFilter transmissionTypes={transmissionTypes} />
              </div>
            ) : null}
            {driveTypes ? (
              <div className={styles.filterSection}>
                <NewDriveTypeFilter driveTypes={driveTypes} />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </NewFilter>
  );
};
